// extracted by mini-css-extract-plugin
export var centerWrapperStyle = "StickyMenuBar-module--centerWrapperStyle--59993";
export var headerStyle = "StickyMenuBar-module--headerStyle--eed29";
export var hideSidebarToggleButtonStyle = "StickyMenuBar-module--hideSidebarToggleButtonStyle--002c4";
export var portalHeaderWrapperStyle = "StickyMenuBar-module--portalHeaderWrapperStyle--1362d";
export var sloganStyle = "StickyMenuBar-module--sloganStyle--221ce";
export var toggleSidebarMenu = "StickyMenuBar-module--toggle-sidebar-menu--24738";
export var toolsStyle = "StickyMenuBar-module--toolsStyle--de2a1";